<template>
  <div class="org-desc">
    <div class="org-detail">
      <div class="org-head">
        <img :src="logo" alt="">
      </div>
      <div class="org-name">{{ name }}</div>
    </div>
    <div class="org-nav">
      <div class="item" v-for="item in leftNav" :key="item.active" :class="{active:item.active == active}"
           @click="go(item.page)">
        <!--        <img :src="item.icon" alt="" class="icon">-->
        <i :class="item.icon"></i>
        <b>{{ item.name }}</b>
        <img src="@/assets/images/jiantounav.png" v-if="item.active == active" alt="" class="jiantou">
      </div>
      <div class="item" @click="go('/admin/orgList')">
        <el-button type="primary" plain>返回机构列表</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import {get_base_info} from "@/api/admin";

export default {
  name: "leftPage",
  data() {
    return {
      logo: '',
      name: '',
      leftNav: [
        {
          name: '基础信息',
          icon: 'iconfont icon-zhengxinxinxi',
          icons: require('@/assets/images/left-jichuxinxi.png'),
          active: 1,
          page: '/admin/orgDetail'
        },
        {
          name: '资金监管信息',
          icon: 'iconfont icon-zijinjianguan',
          icons: require('@/assets/images/left-zijinjianguanxinxi.png'),
          active: 2,
          page: '/admin/moneySupervision'
        },
        {
          name: '机构运营信息',
          icon: 'iconfont icon-yunyingfenxi',
          icons: require('@/assets/images/left-jigouyunyingxinxi.png'),
          active: 3,
          page: '/admin/orgOperation'
        },
        {
          name: '监管信息',
          icon: 'iconfont icon-jianguanguanli',
          icons: require('@/assets/images/left-xinxijianguan.png'),
          active: 4,
          page: '/admin/supervision'
        },
        {
          name: '风险预警',
          icon: 'iconfont icon-yujing',
          icons: require('@/assets/images/left-fengxianyujing.png'),
          active: 5,
          page: '/admin/riskWarning'
        },
        {
          name: '申请闭店',
          icon: 'iconfont icon-wodeshensu',
          icons: require('@/assets/images/left-fengxianyujing.png'),
          active: 6,
          page: '/admin/closeshop'
        }
      ]
    }
  },
  props: {
    active: {
      type: [String, Number],
      default: ''
    },
    org_id: {
      type: [String, Number],
      default: ''
    },
  },
  computed: {
    // user() {
    //   return this.$store.state.user
    // },
  },
  components: {},
  created() {
    // this.$nextTick(() => {
    //   this.nav.map(item => {
    //     if(item.active == this.active){
    //       item.show = true
    //     }
    //   })
    // })
    // this.org_id = this.$route.query.org_id
    this.init()
  },
  methods: {

    async init() {
      let _data = await get_base_info(this.org_id);
      this.logo = _data.data.logo
      this.name = _data.data.org_name
    },

    go(path) {
      // if(path == 1){
      //   let routerJump = this.$router.resolve({
      //     path: '/help',
      //     query: {
      //
      //     }
      //   });
      //   window.open(routerJump.href, "_parent");
      //   return
      // }
      // let nowPath = this.$route.path
      // if(path !== nowPath) {
      this.$router.push({
        path: path,
        query: {
          org_id: this.$route.query.org_id,
          org_name: this.$route.query.org_name,
          license: this.$route.query.license,
          jianguan: this.$route.query.jianguan,
          is_lock: this.$route.query.is_lock,
          peixun_lei: this.$route.query.peixun_lei,
          page: this.$route.query.page
        }
      })
      // }
    },
  },
  watch: {},
  filters: {}
}
</script>

<style scoped lang="scss">
.org-desc {
  min-height: calc(100vh - (173px + 199px));
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  height: 100%;

  .org-nav {
    flex: 1;
    width: 100%;
    //background: #2791ff;
    background-image: linear-gradient(0deg,
      #7eb6ff 0%,
      #2791ff 100%);
    border-radius: 10px;
    margin-top: 20px;

    .item {
      width: 100%;
      height: 100px;
      border-bottom: 1px solid rgba(255, 255, 255, .4);
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      cursor: pointer;

      &.active {
        background: rgba(255, 255, 255, .25);
      }

      .iconfont {
        margin-right: 15px;
        font-size: 30px;
        color: #ffffff;

      }

      b {
        font-weight: normal;
        font-size: 20px;
        color: #ffffff;
        width: 120px;
      }

      .jiantou {
        position: absolute;
        top: 45px;
        right: -8px;
      }
    }
  }

  .org-detail {
    width: 100%;
    height: 220px;
    background-color: #2791ff;
    border-radius: 10px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    padding: 20px;

    .org-name {
      width: 100%;
      text-align: center;
      font-size: 18px;
      color: #ffffff;
      padding-top: 15px;
    }

    .org-head {
      width: 68px;
      height: 68px;
      border-radius: 34px;
      margin: 0 auto;
      overflow: hidden;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
}
</style>


